export default defineNuxtRouteMiddleware((to) => {
  if ('events' in to.query) {
    useState('areEventsOpened').value = true;
  }
});
